/** @jsx jsx */
import { jsx, Box, Container } from 'theme-ui';
import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import ReactPlayer from 'react-player/wistia';
import YouTube from 'react-youtube';
import { getYoutubeId } from '../../helpers/general';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import PlayerLightIcon from '../../components/playerLightIcon';

// Styles
import { baseStyle } from './style';
import merge from 'lodash.merge';

interface VideoBackgroundOutboundProps extends Section {
  backgroundImage: {
    backgroundImage: ImageType;
  };
  title: {
    title: string;
  };
  video: {
    alternativeText: string;
    enableYoutubeVideo: boolean;
    image: ImageType;
    url: string;
    title: string;
  };
  outOfBounds: {
    outOfBoundsTrueFalse: boolean;
  };
}

const VideoBackgroundOutbound: SectionComponent<VideoBackgroundOutboundProps> = React.memo(
  ({ backgroundImage, title, video, outOfBounds }) => {
    // Refs
    const refPlayer = React.useRef();

    const youTubeId = getYoutubeId(video.url);

    const playerStyle =
      youTubeId && video?.enableYoutubeVideo
        ? merge({}, baseStyle.videoContainer, baseStyle.youtubeVideoContainer)
        : baseStyle.videoContainer;

    return (
      <BackgroundImage
        fluid={
          backgroundImage.backgroundImage.localFile?.childImageSharp?.fluid
        }
        sx={baseStyle.mainBackgroundImage}
      >
        <Container>
          {title && (
            <Text type={TEXT_TYPES.H1_BOLD} sx={baseStyle.title}>
              {title.title}
            </Text>
          )}
          <Box
            sx={{
              ...playerStyle,
              ...(outOfBounds.outOfBoundsTrueFalse
                ? baseStyle.outOfBounds
                : {}),
            }}
          >
            {!video?.enableYoutubeVideo && (
              <ReactPlayer
                ref={refPlayer}
                url={video.url}
                width="100%"
                height="100%"
                light={encodeURI(video.image?.localFile.publicURL) || true}
                controls
                playIcon={<PlayerLightIcon />}
                playing
              />
            )}

            {video?.enableYoutubeVideo && getYoutubeId(video.url) && (
              <YouTube videoId={getYoutubeId(video.url)} />
            )}
          </Box>
        </Container>
      </BackgroundImage>
    );
  },
);

export default VideoBackgroundOutbound;
